import script from "./LoginView.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoginView.vue?vue&type=script&lang=ts&setup=true"

import "./LoginView.vue?vue&type=style&index=0&id=72073c4a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72073c4a"]])

export default __exports__